<template>
  <footer class="site-footer">
    <div class="footer-links">
      <router-link to="/about">关于我们</router-link>
      <router-link to="/research">研究成果</router-link>
      <router-link to="/contact">合作交流</router-link>
      <router-link to="/about">关于我们</router-link>
      <a href="research.html">研究成果</a>
      <a href="partners.html">合作交流</a>
      <a href="contact.html">联系我们</a>
    </div>
    <p>© 2025 人工智能和机器人实验室 版权所有</p>
    <p>
      地址：深圳市龙华区观澜街道观光路 | 电话：XXX-12345678 |
      邮箱：contact@xxx-lab.edu.cn
      <a href="https://beian.miit.gov.cn/">粤ICP备2025511930号</a>
    </p>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped>
.site-footer {
  background: #003366;
  color: #fff;
  text-align: center;
  padding: 20px;
  margin-top: 50px;
}

.footer-links {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.footer-links a {
  color: #fff;
  margin: 5px 10px;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}
</style>
